import "../styles/Ourplan.css";

const Ourplan = () => {
    return (
        <div className="ourplan-main">
            <h1 className="our">OUR CUSTOMERS</h1>
            <div className="price-details">
                <div id="c6"></div>
                <div id="c2"></div>
                <div id="c3"></div>
                <div id="c4"></div>
                <div id="c5"></div>
                <div id="c8"></div>
                <div id="c7"></div>
                <div id="c9"></div>
                <div id="c10"></div>
            </div>
        </div>
    );
}

export default Ourplan;
